import { Button, Layout, Result } from "antd";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { PATHNAME } from "../../res/pathName";

const NotFound = () => {
  const user = Cookies.get("jwt");
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Result
        style={{ margin: "auto" }}
        status={"404"}
        subTitle="ขออภัย ไม่พบหน้าที่คุณต้องการ"
        extra={
          <Button
            type="primary"
            onClick={() => {
              user ? navigate(PATHNAME.LOGIN) : navigate(PATHNAME.LOGIN);
            }}
          >
            กลับไปหน้าหลัก
          </Button>
        }
      />
    </Layout>
  );
};

export default NotFound;
